// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"6f0391e9","229":"2a8a26e9","365":"438c7857","453":"a5072149","859":"e95321b2","928":"f1e61501"}[chunkId] + ".chunk.js";
};